import { render, staticRenderFns } from "./MiraInsurance.vue?vue&type=template&id=49dafe42&scoped=true&"
import script from "./MiraInsurance.vue?vue&type=script&lang=ts&"
export * from "./MiraInsurance.vue?vue&type=script&lang=ts&"
import style0 from "./MiraInsurance.vue?vue&type=style&index=0&id=49dafe42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49dafe42",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VProgressCircular,VRow})
